module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button/button.component.scss
// module id = ./src/app/shared/button/button.component.scss
// module chunks = main